import { atom } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { RestaurantSearchCourse } from '~/components/course/RestaurantSearchCourse.frag'
import { graphql } from '~/lib/graphql'
import { getFragmentData } from '~/lib/graphql'
import { createQueryAtom, createQueryOptions } from '~/stores/jotaiQueryHelper'
import { restaurantId$ } from '../../scope'

export const GuideMenuCourses = graphql(/* GraphQL */ `
  query GuideMenuCourses($restaurantId: RestaurantId!, $searchInput: SearchInput = {}) {
    restaurant(restaurantId: $restaurantId) {
      searchCourses(input: $searchInput) {
        edges {
          node {
            ...RestaurantSearchCourse
          }
        }
      }
    }
  }
`)

const query$ = createQueryAtom<typeof GuideMenuCourses>()

const queryResult$ = atomWithQuery((get) =>
  createQueryOptions(
    GuideMenuCourses,
    // enabled でチェックするので ! してよい
    { restaurantId: get(restaurantId$)! },
    get(query$).fn,
    {
      enabled: get(restaurantId$) !== undefined,
      staleTime: 60 * 60 * 1000,
    }
  )
)

export const courses$ = atom((get) =>
  get(queryResult$).data?.restaurant?.searchCourses.edges.map((edge) =>
    getFragmentData(RestaurantSearchCourse, edge.node)
  )
)
